/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Reply_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event reply" |
*
* @param {Notes_Reply_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_reply_aria_label = /** @type {((inputs?: Notes_Reply_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Reply_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reponse d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisantwort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risposta all'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ответ на событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Respuesta al evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件回复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント返信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना प्रतिक्रिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resposta ao evento")
	return /** @type {LocalizedString} */ ("Event reply")
});